import {useState} from 'react';

function useInputState (initialVal) {
    const [value, setValue] = useState(initialVal);
    
    const edit = (e) => {
        setValue(e.target.value);
    }

    const reset = () => {
        setValue("");
    }

    return [value, edit, reset];
}

export default useInputState;

export const  useEditState =  (initialVal) => {
    const [value, setValue] = useState(initialVal);
    
    const edit = (e) => {
        setValue(e.target.value);
    }

    return [value, edit];
}